import { SkillLabelUpdateResponse } from '../../../../models';

export function formatLabelUpdateSummary(response: SkillLabelUpdateResponse): string {
  const total = Object.values(response.updatedCounts ?? {}).reduce((sum, count) => sum + count, 0);
  const base = total === 1 ? 'Updated 1 catalog reference.' : `Updated ${total} catalog references.`;
  const warning = response.warnings?.[0];
  return warning ? `${base} ${warning}` : base;
}
